[
  [
    {
      "id": "acid-splash",
      "title": "Acid Splash",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:acid-splash"
    },
    {
      "id": "booming-blade",
      "title": "Booming Blade",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:booming-blade"
    },
    {
      "id": "create-bonfire",
      "title": "Create Bonfire",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:create-bonfire"
    },
    {
      "id": "dancing-lights",
      "title": "Dancing Lights",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:dancing-lights"
    },
    {
      "id": "fire-bolt",
      "title": "Fire Bolt",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:fire-bolt"
    },
    {
      "id": "frostbite",
      "title": "Frostbite",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:frostbite"
    },
    {
      "id": "green-flame-blade",
      "title": "Green-Flame Blade",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:green-flame-blade"
    },
    {
      "id": "guidance",
      "title": "Guidance",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:guidance"
    },
    {
      "id": "light",
      "title": "Light",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:light"
    },
    {
      "id": "lightning-lure",
      "title": "Lightning Lure",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:lightning-lure"
    },
    {
      "id": "mage-hand",
      "title": "Mage Hand",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mage-hand"
    },
    {
      "id": "magic-stone",
      "title": "Magic Stone",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:magic-stone"
    },
    {
      "id": "mending",
      "title": "Mending",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mending"
    },
    {
      "id": "message",
      "title": "Message",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:message"
    },
    {
      "id": "poison-spray",
      "title": "Poison Spray",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:poison-spray"
    },
    {
      "id": "prestidigitation",
      "title": "Prestidigitation",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:prestidigitation"
    },
    {
      "id": "ray-of-frost",
      "title": "Ray of Frost",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:ray-of-frost"
    },
    {
      "id": "resistance",
      "title": "Resistance",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:resistance"
    },
    {
      "id": "shocking-grasp",
      "title": "Shocking Grasp",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:shocking-grasp"
    },
    {
      "id": "spare-the-dying",
      "title": "Spare the Dying",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:spare-the-dying"
    },
    {
      "id": "sword-burst",
      "title": "Sword Burst",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:sword-burst"
    },
    {
      "id": "thorn-whip",
      "title": "Thorn Whip",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:thorn-whip"
    },
    {
      "id": "thunderclap",
      "title": "Thunderclap",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:thunderclap"
    }
  ],
  [
    {
      "id": "absorb-elements",
      "title": "Absorb Elements",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:absorb-elements"
    },
    {
      "id": "alarm",
      "title": "Alarm",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:alarm"
    },
    {
      "id": "arcane-weapon",
      "title": "Arcane Weapon (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:arcane-weapon"
    },
    {
      "id": "catapult",
      "title": "Catapult",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:catapult"
    },
    {
      "id": "cure-wounds",
      "title": "Cure Wounds",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:cure-wounds"
    },
    {
      "id": "detect-magic",
      "title": "Detect Magic",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-magic"
    },
    {
      "id": "disguise-self",
      "title": "Disguise Self",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:disguise-self"
    },
    {
      "id": "expeditious-retreat",
      "title": "Expeditious Retreat",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:expeditious-retreat"
    },
    {
      "id": "faerie-fire",
      "title": "Faerie Fire",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:faerie-fire"
    },
    {
      "id": "false-life",
      "title": "False Life",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:false-life"
    },
    {
      "id": "feather-fall",
      "title": "Feather Fall",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:feather-fall"
    },
    {
      "id": "grease",
      "title": "Grease",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:grease"
    },
    {
      "id": "identify",
      "title": "Identify",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:identify"
    },
    {
      "id": "jump",
      "title": "Jump",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:jump"
    },
    {
      "id": "longstrider",
      "title": "Longstrider",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:longstrider"
    },
    {
      "id": "purify-food-and-drink",
      "title": "Purify Food and Drink",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:purify-food-and-drink"
    },
    {
      "id": "sanctuary",
      "title": "Sanctuary",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sanctuary"
    },
    {
      "id": "snare",
      "title": "Snare",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:snare"
    },
    {
      "id": "tashas-caustic-brew",
      "title": "Tasha's Caustic Brew",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:tashas-caustic-brew"
    }
  ],
  [
    {
      "id": "aid",
      "title": "Aid",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:aid"
    },
    {
      "id": "air-bubble",
      "title": "Air Bubble",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:air-bubble"
    },
    {
      "id": "alter-self",
      "title": "Alter Self",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:alter-self"
    },
    {
      "id": "arcane-lock",
      "title": "Arcane Lock",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:arcane-lock"
    },
    {
      "id": "blur",
      "title": "Blur",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:blur"
    },
    {
      "id": "continual-flame",
      "title": "Continual Flame",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:continual-flame"
    },
    {
      "id": "darkvision",
      "title": "Darkvision",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:darkvision"
    },
    {
      "id": "enhance-ability",
      "title": "Enhance Ability",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enhance-ability"
    },
    {
      "id": "enlarge-reduce",
      "title": "Enlarge/Reduce",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enlarge-reduce"
    },
    {
      "id": "heat-metal",
      "title": "Heat Metal",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:heat-metal"
    },
    {
      "id": "invisibility",
      "title": "Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:invisibility"
    },
    {
      "id": "kinetic-jaunt",
      "title": "Kinetic Jaunt",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:kinetic-jaunt"
    },
    {
      "id": "lesser-restoration",
      "title": "Lesser Restoration",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:lesser-restoration"
    },
    {
      "id": "levitate",
      "title": "Levitate",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:levitate"
    },
    {
      "id": "magic-mouth",
      "title": "Magic Mouth",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:magic-mouth"
    },
    {
      "id": "magic-weapon",
      "title": "Magic Weapon",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:magic-weapon"
    },
    {
      "id": "protection-from-poison",
      "title": "Protection from Poison",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-poison"
    },
    {
      "id": "pyrotechnics",
      "title": "Pyrotechnics",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:pyrotechnics"
    },
    {
      "id": "rope-trick",
      "title": "Rope Trick",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:rope-trick"
    },
    {
      "id": "see-invisibility",
      "title": "See Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:see-invisibility"
    },
    {
      "id": "skywrite",
      "title": "Skywrite",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:skywrite"
    },
    {
      "id": "spider-climb",
      "title": "Spider Climb",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spider-climb"
    },
    {
      "id": "vortex-warp",
      "title": "Vortex Warp",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:vortex-warp"
    },
    {
      "id": "web",
      "title": "Web",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:web"
    }
  ],
  [
    {
      "id": "ashardalons-stride",
      "title": "Ashardalon's Stride",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:ashardalons-stride"
    },
    {
      "id": "blink",
      "title": "Blink",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:blink"
    },
    {
      "id": "catnap",
      "title": "Catnap",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:catnap"
    },
    {
      "id": "create-food-and-water",
      "title": "Create Food and Water",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:create-food-and-water"
    },
    {
      "id": "dispel-magic",
      "title": "Dispel Magic",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:dispel-magic"
    },
    {
      "id": "elemental-weapon",
      "title": "Elemental Weapon",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:elemental-weapon"
    },
    {
      "id": "flame-arrows",
      "title": "Flame Arrows",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:flame-arrows"
    },
    {
      "id": "flame-stride",
      "title": "Flame Stride (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:flame-stride"
    },
    {
      "id": "fly",
      "title": "Fly",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fly"
    },
    {
      "id": "glyph-of-warding",
      "title": "Glyph of Warding",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:glyph-of-warding"
    },
    {
      "id": "haste",
      "title": "Haste",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:haste"
    },
    {
      "id": "house-of-cards-ua",
      "title": "House of Cards (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:house-of-cards-ua"
    },
    {
      "id": "intellect-fortress",
      "title": "Intellect Fortress",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:intellect-fortress"
    },
    {
      "id": "protection-from-energy",
      "title": "Protection from Energy",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-energy"
    },
    {
      "id": "revivify",
      "title": "Revivify",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:revivify"
    },
    {
      "id": "tiny-servant",
      "title": "Tiny Servant",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tiny-servant"
    },
    {
      "id": "water-breathing",
      "title": "Water Breathing",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:water-breathing"
    },
    {
      "id": "water-walk",
      "title": "Water Walk",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:water-walk"
    }
  ],
  [
    {
      "id": "arcane-eye",
      "title": "Arcane Eye",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:arcane-eye"
    },
    {
      "id": "elemental-bane",
      "title": "Elemental Bane",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:elemental-bane"
    },
    {
      "id": "fabricate",
      "title": "Fabricate",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:fabricate"
    },
    {
      "id": "freedom-of-movement",
      "title": "Freedom of Movement",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:freedom-of-movement"
    },
    {
      "id": "leomunds-secret-chest",
      "title": "Leomund's Secret Chest",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:leomunds-secret-chest"
    },
    {
      "id": "mordenkainens-faithful-hound",
      "title": "Mordenkainen's Faithful Hound",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-faithful-hound"
    },
    {
      "id": "mordenkainens-private-sanctum",
      "title": "Mordenkainen's Private Sanctum",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-private-sanctum"
    },
    {
      "id": "otilukes-resilient-sphere",
      "title": "Otiluke's Resilient Sphere",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:otilukes-resilient-sphere"
    },
    {
      "id": "stone-shape",
      "title": "Stone Shape",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:stone-shape"
    },
    {
      "id": "stoneskin",
      "title": "Stoneskin",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:stoneskin"
    },
    {
      "id": "summon-construct",
      "title": "Summon Construct",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:summon-construct"
    }
  ],
  [
    {
      "id": "animate-objects",
      "title": "Animate Objects",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:animate-objects"
    },
    {
      "id": "bigbys-hand",
      "title": "Bigby's Hand",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:bigbys-hand"
    },
    {
      "id": "create-spelljamming-helm",
      "title": "Create Spelljamming Helm",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:create-spelljamming-helm"
    },
    {
      "id": "creation",
      "title": "Creation",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:creation"
    },
    {
      "id": "greater-restoration",
      "title": "Greater Restoration",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:greater-restoration"
    },
    {
      "id": "skill-empowerment",
      "title": "Skill Empowerment",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:skill-empowerment"
    },
    {
      "id": "transmute-rock",
      "title": "Transmute Rock",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:transmute-rock"
    },
    {
      "id": "wall-of-stone",
      "title": "Wall of Stone",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-stone"
    }
  ],
  [],
  [],
  [],
  []
]
